let slickDefaults = require('../slick-default/slick-default');
let debounce = require('../../modules/debounce');
require('./brochure-slider.less');

let size = require('../../modules/size');

jQuery(function() {
    $('.js-brochure-slider').slick(
        $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: size.tabletBig,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: size.tablet,
                    settings: { slidesToShow: 1 }
                }
            ]
        })
    );

    var $slider = $('.js-brochure-slider-vertical');

    if ($slider.length > 0) {
        var verticalBrochureSliderOptions = $.extend({}, slickDefaults.params, {
            slidesToShow: 3,
            vertical: true,
            verticalSwiping: false,
            responsive: [
                {
                    breakpoint: size.tablet,
                    settings: { slidesToShow: 1, vertical: false }
                }
            ]
        });

        $slider.slick(verticalBrochureSliderOptions);

        resizeVerticalBrochureSlider($slider);

        debounce.setResizeDebounce(function() {
            resizeVerticalBrochureSlider($slider);
        });
    }

    //подогнать высоту слайдера под высоту основного контента
    function resizeVerticalBrochureSlider($slider) {
        if (window.innerWidth < size.tablet) return false;

        var $mainColumn = $('#brochures-list-main-column');
        var $mainColumnAddition = $('#main-column-addition');

        if (window.innerWidth < size.desktop) $mainColumnAddition.insertAfter($mainColumn);
        else $mainColumn.append($mainColumnAddition);

        var mainColumnHeight = $mainColumn.height();
        var brochureHeight = $slider
            .find('.brochure-slider__item')
            .first()
            .innerHeight();
        var slideCount = 3;

        if (mainColumnHeight > brochureHeight * 3) slideCount = Math.round(mainColumnHeight / brochureHeight) - 1;

        var curSlideCount = $slider.get(0).slick.options.slidesToShow;

        if (curSlideCount != slideCount) {
            $slider.slick('unslick');
            $slider.slick(
                $.extend({}, verticalBrochureSliderOptions, {
                    slidesToShow: slideCount
                })
            );
        }
    }
});



// WEBPACK FOOTER //
// ./blocks/brochure-slider/brochure-slider.js